import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { History } from "lucide-react";

export const stampShort = (iso) => {
  const dt = new Date(iso);
  if (isNaN(dt.getTime())) return "";
  return dt.toLocaleString(undefined, { month: "short", day: "numeric", year: "numeric", hour: "numeric", minute: "2-digit" });
};

/** Who changed which client detail, and when. */
export function ClientChangeHistory({ clientId, limit = 8 }) {
  const [data, setData] = useState(null);
  useEffect(() => {
    api.get(`/clients/${clientId}/field-history`).then((r) => setData(r.data)).catch(() => setData({ labels: {}, history: [] }));
  }, [clientId]);

  const rows = (data?.history || []).slice(0, limit);
  return (
    <div data-testid="client-change-history">
      <div className="flex items-center gap-1.5 text-xs font-semibold text-slate-500">
        <History className="h-3.5 w-3.5" /> Change history
      </div>
      {!data ? (
        <div className="mt-2 text-xs text-slate-400">Loading…</div>
      ) : rows.length === 0 ? (
        <div className="mt-2 text-xs text-slate-400" data-testid="client-change-history-empty">No changes recorded yet.</div>
      ) : (
        <ul className="mt-2 space-y-1.5">
          {rows.map((h) => (
            <li key={h.id} className="text-xs text-slate-600 border-l-2 border-slate-200 pl-2" data-testid={`client-change-${h.id}`}>
              <span className="font-semibold">{data.labels?.[h.field] || h.field}</span>
              {" "}changed{h.old_value ? <> from <span className="text-slate-400 line-through">{h.old_value}</span></> : null} to <span className="text-slate-800">{h.new_value || "—"}</span>
              <div className="text-[11px] text-slate-400">{h.changed_by || "—"} · {stampShort(h.changed_at)}</div>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}

/** One-line "last changed by X" hint for a single field. */
export const LastChangedHint = ({ entry }) => (
  entry ? <p className="text-[11px] text-slate-400 mt-0.5" data-testid={`last-changed-${entry.field}`}>Last changed by {entry.changed_by || "—"} · {stampShort(entry.changed_at)}</p> : null
);
